import app from 'flarum/forum/app';
import Component from 'flarum/common/Component';
import LoadingIndicator from 'flarum/common/components/LoadingIndicator';
import ItemList from 'flarum/common/utils/ItemList';
import LangDisplayName from '../util/LangDisplayName';
import TranslatedPostFooter from './TranslatedPostFooter';
import TranslationSourceLabel from './TranslationSourceLabel';
import { generateActionItems } from '../util/generateActionItems';

/**
 * Translated discussion title, rendered in place of the hero title.
 */
export default class TranslatedDiscussionTitle extends Component {
  view() {
    const {
      state
    } = this.attrs;
    if (state.loading || !state.currentTranslation) {
      return m("div", {
        className: "DiscussionTitle DiscussionTitle--translated"
      }, m(LoadingIndicator, null));
    }
    return m("div", {
      className: "DiscussionHero-title DiscussionTitle--translated"
    }, m("div", {
      className: "Title-header"
    }, this.headerItems(state).toArray()), m("h1", {
      className: "DiscussionHero-title"
    }, state.currentTranslation), m("div", {
      className: "Title-footer"
    }, this.footerItems(state).toArray()));
  }
  headerItems(state) {
    const items = new ItemList();
    const discussion = state.item;
    const detected = discussion?.detectedLang?.();
    const from = detected && detected !== 'unknown' ? LangDisplayName(detected) : app.translator.trans('itqan-translate.forum.unknown-language');
    const to = LangDisplayName(state.language);
    items.add('translation-ai', m(TranslationSourceLabel, {
      from: from,
      to: to
    }), 50);
    items.add('actions', m("div", {
      className: "TitleMeta TitleTranslation--action-items"
    }, generateActionItems(state).toArray()), -100);
    return items;
  }
  footerItems(state) {
    const items = new ItemList();
    items.add('translation-date', m(TranslatedPostFooter, {
      updatedAt: state.updatedAt,
      provider: state.provider
    }), 90);
    return items;
  }
}
flarum.reg.add('itqan-translate', 'forum/components/TranslatedDiscussionTitle', TranslatedDiscussionTitle);